<template>
	<div role="button" tabindex="0" class="share-sheet__option" @click="props.callback(props)">
		<div class="share-sheet__icon" :class="{'share-sheet__icon--colored': !!props.color}" :style="{backgroundColor: props.color}">
			<Icon :icon="props.icon"/>
		</div>
		<span class="share-sheet__name">{{props.name }}</span>
	</div>
</template>

<script setup lang="ts">
import type {ShareSheetOptionProps} from "./ShareSheetOptionProps";

const props = defineProps<ShareSheetOptionProps>();
</script>

<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.share-sheet__option {
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
  cursor: pointer;
}
.share-sheet__option:hover {
  opacity: 0.9;
}
.share-sheet__option:active {
  opacity: 0.8;
}
.share-sheet__option .share-sheet__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5e6b6b;
  border-radius: 100%;
  background-color: #f4f4f5;
  width: 48px;
  height: 48px;
  margin: 0 var(--van-padding-md);
}
.share-sheet__option .share-sheet__icon.share-sheet__icon--colored {
  color: #ffffff;
}
.share-sheet__option .share-sheet__name {
  margin-top: 8px;
  padding: 0 4px;
  color: #465050;
  font-size: 12px;
}
</style>